import React from 'react';

// App-wide safety net. Without this, any render-time exception in a page unmounts
// the entire React tree and the user sees a blank white screen with no clue what
// happened. This catches the error, shows a readable message + reload, and logs
// the stack to the console so it's diagnosable.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface the full stack in the console for debugging in production.
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="cs-errbound">
        <div className="cs-errbound-card">
          <h1>Something broke on this page</h1>
          <p className="cs-help">
            The page hit an unexpected error and couldn’t render. Your work isn’t lost — try
            reloading, or go back to the home page.
          </p>
          <pre className="cs-errbound-msg">{String(error.message || error)}</pre>
          <div className="cs-errbound-actions">
            <button className="cs-btn cs-btn-primary cs-btn-sm" onClick={() => window.location.reload()}>
              Reload
            </button>
            <button className="cs-btn cs-btn-ghost cs-btn-sm" onClick={() => { window.location.href = '/'; }}>
              Go home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
